
import { FC } from 'react';
import ProductSelection from "@/components/analytics/ProductSelection";
import TimeRangeSelector from "@/components/analytics/TimeRangeSelector";
import { Group, Product } from "@/lib/types";

interface AnalyticsHeaderProps {
  products: Product[];
  groups: Group[];
  selectedProductId: string;
  setSelectedProductId: (id: string) => void;
  selectedGroupId: string;
  handleGroupChange: (groupId: string) => void;
  timeRange: "7days" | "30days" | "90days";
  setTimeRange: (range: "7days" | "30days" | "90days") => void;
}

const AnalyticsHeader: FC<AnalyticsHeaderProps> = ({
  products,
  groups,
  selectedProductId,
  setSelectedProductId,
  selectedGroupId,
  handleGroupChange,
  timeRange,
  setTimeRange
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
      <h1 className="text-2xl font-bold">Analytics</h1>
      
      <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <ProductSelection
          products={products}
          groups={groups}
          selectedProductId={selectedProductId}
          setSelectedProductId={setSelectedProductId}
          selectedGroupId={selectedGroupId}
          handleGroupChange={handleGroupChange}
        />
        
        <TimeRangeSelector 
          timeRange={timeRange}
          setTimeRange={setTimeRange}
        />
      </div>
    </div>
  );
};

export default AnalyticsHeader;
